import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
  SimpleChanges,
  Input,
  OnChanges,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionStorageService, LocalStorageService } from "ngx-webstorage";
import { AppQueries } from "src/app/state";
import { ShortcutService } from "src/app/common/service/shortcut.service";
import { debounceTime, Subject, Subscription } from "rxjs";
import { EventManagerService } from "src/app/common/service/event-manager.service";
import { Constant } from "src/app/common/constant";
import { DialogService } from "src/app/common/service/dialog.service";
import { BusinessOperationsService } from "../../business-operations.service";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: "search-agency",
  styleUrls: ["./search-agency.component.scss"],
  templateUrl: "./search-agency.component.html",
  encapsulation: ViewEncapsulation.None
})
export class SearchAgencyComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @Input() agencyOrganizationId: any;
  @Input() key: any = 'id';
  @Input() isFullEmit: boolean = false;
  @Output() result: EventEmitter<any> = new EventEmitter(); 
  public Constant = Constant;
  subscriptions?: Subscription[] = [];
  agencyPartners: any[] = [];
  callSearchAgency$ = new Subject();
  remainingAgency: any;
  userProfile: any;
  constructor(
    public eventManager: EventManagerService,
    public dialogService: DialogService,
    public route: ActivatedRoute,
    public sessionStorageService: SessionStorageService,
    private businessOperationsService: BusinessOperationsService,
    private appQueries: AppQueries) {

  }

  ngOnInit() {
    this.subscriptions.push(
      this.appQueries.userProfile$.subscribe((userProfile) => {
        this.userProfile = userProfile;
      }),
      this.callSearchAgency$.pipe(
        debounceTime(500),
        ).subscribe((event)=> { return this.loadAgencyPartner(event);})
    )
    this.searchAgency(undefined);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.agencyOrganizationId && changes.agencyOrganizationId.currentValue) {
      this.searchAgency(undefined);
    }
  }
  ngOnDestroy() {
    ShortcutService.removeFuncEsc();
    this.eventManager.destroys(this.subscriptions);
  }
  ngAfterViewInit(): void {
  }
  changeAgencyPartner(agencyPartner) {
    if (!agencyPartner) {
      this.result.emit(undefined);
    }
    agencyPartner = agencyPartner + '';
    const split = agencyPartner.split('-');
    const agencyCode = (split.pop() || '').trim();
    const findAgency = this.agencyPartners.find(item => agencyCode === item.agencyPartnerCode) || {};
    if (!findAgency) {
      return;
    }
    if (this.isFullEmit) {
      this.result.emit(findAgency);
    } else this.result.emit(findAgency[this.key]);
  }
  searchAgency(text) {
    this.callSearchAgency$.next(text);
  }
  loadAgencyPartner(text) {
    const body = {
      searchField: text,
      page: 1,
      size: 10,
      statusCodes: ['PARTNER_INIT', 'PARTNER_PENDING', 'PARTNER_REJECT', 'PARTNER_CONSULTANT'],
      agencyOrganizationId: this.userProfile.id,
      originAgencyOrganizationId: this.userProfile.id,
      isNoAum : true
    }
    this.businessOperationsService
    .queryAgency(body)
    .subscribe(
      (res: any) => {
        if (!res) {
          return;
        }
        this.agencyPartners = (res.data.list || []).map((item) => {
          item.showName = `${item.name} - ${item.agencyPartnerCode}`;
          return item;
        });
        const totalItems = res.data.total;
        this.remainingAgency = totalItems - 20 > 0 ? totalItems - 20 : 0;
      });
  }
}
